import React from 'react'
import StyledBox from './StyledBox'
import { any } from 'prop-types'

const MobileFilterHeaderContainer = ({ children }) => {
  return <StyledBox>{children}</StyledBox>
}
MobileFilterHeaderContainer.propTypes = {
  children: any
}

export default MobileFilterHeaderContainer
